/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioCompactDTO { 
    id?: string;
    tipo_servizio?: ServizioCompactDTOTipoServizioEnum;
    tipo_pratica_id?: string;
    tipo_pratica_codice?: string;
    comune_id?: string;
    comune_nome?: string;
}
export enum ServizioCompactDTOTipoServizioEnum {
    MENSA = 'MENSA'
};



